export const URI = 'data:application/vnd.ms-excel;base64,';
export const TEMPLATE = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><meta http-equiv="content-type" content="application/vnd.ms-excel; charset=UTF-8"><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body><table>{table}</table></body></html>';


export const exportFromTable = (element: HTMLElement, filename?: string) => {
  exportFromHtml(element.innerHTML, filename);
}

export const exportFromHtml = (html: string, filename?: string) => {
  const context = {
    worksheet: 'Worksheet',
    table: html
  }
  const link = document.createElement('a');
  link.download = filename ?? 'export.xls';
  link.href = URI + base64(format(context));
  link.click();
}

const base64 = (text: string) => window.btoa(unescape(encodeURIComponent(text)));

const format = (context: object) => {
  return TEMPLATE.replace(/{(\w+)}/g, (_sub: string, key: string) => {
    return context[key];
  });
}
